import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import CaseStudies from "@/components/CaseStudies";
import CTA from "@/components/CTA";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/toaster";

const Home = () => {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <Hero />
      <Services />
      <About />
      <CaseStudies />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
};

// Placeholder pages
const ServicesPage = () => (
  <div className="min-h-screen bg-black">
    <Navbar />
    <div className="pt-32 pb-20 text-center">
      <h1 className="text-4xl text-white">Servizi - Coming Soon</h1>
    </div>
    <Footer />
  </div>
);

const CaseStudiesPage = () => (
  <div className="min-h-screen bg-black">
    <Navbar />
    <div className="pt-32 pb-20 text-center">
      <h1 className="text-4xl text-white">Case Studies - Coming Soon</h1>
    </div>
    <Footer />
  </div>
);

const AboutPage = () => (
  <div className="min-h-screen bg-black">
    <Navbar />
    <div className="pt-32 pb-20 text-center">
      <h1 className="text-4xl text-white">Chi Siamo - Coming Soon</h1>
    </div>
    <Footer />
  </div>
);

const ContactPage = () => (
  <div className="min-h-screen bg-black">
    <Navbar />
    <div className="pt-32 pb-20 text-center">
      <h1 className="text-4xl text-white">Contatti - Coming Soon</h1>
    </div>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servizi" element={<ServicesPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/chi-siamo" element={<AboutPage />} />
          <Route path="/contatti" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
